import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {AccountService} from '../../../services/account.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { AccountActions } from '../actions/account.actions';
import { UtilsService } from '../../../services/utils.service';
import { AccountListFilter } from '../account.model';


@Injectable()
export class AccountEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private accountService = inject(AccountService);
  private utils = inject(UtilsService);

  constructor() {}

  ReadAccountInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AccountActionTypes.GetAccounts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.accountService.ReadAccountInfo(user.otp).pipe(
        map((res: any) => {
          if (!(res.length > 0)) {
            return new featureActions.NoAccountsChanged();
          } else {
            return new featureActions.LoadAccounts({accounts: res});
          }

        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetAccountsFail());
        })
      );
    })
  ));
  GetClientAccount$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AccountActionTypes.GetClientAccount),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.accountService.ReadEndUserAccountInfo(user.otp).pipe(
        map((res: any) => {

          if (res.length) {
            return new featureActions.NoAccountsChanged();
          } else {
            const token = JSON.parse(this.utils.getToken());
            this.utils.writeToken({...token, username: res.Account});
            return new featureActions.LoadAccounts({accounts: [res]});
          }

        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetAccountsFail());
        })
      );
    })
  ));
  ReadAllAccountInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AccountActionTypes.GetAllAccounts),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      if (!user.authority) {
        return of(new featureActions.NoAccountsChanged());
      }
      return this.accountService.ReadAccountInfo(user.otp).pipe(
        switchMap((res: any) => {
          if (res.length > 0) {
            const filter = {Authority: user.authority, AuthorityRegion: user.AuthorityRegion} as AccountListFilter;
            return[new featureActions.SelectAccountListFilters(filter),
                   new featureActions.LoadAccounts({accounts: res})];
            // if (user.authority === 2) {
            //   return of(new featureActions.LoadAccounts({accounts: res}));
            // } else if (user.authority === 1 && Array.isArray(user.AuthorityRegion)) {
            //   const data = res.filter(item => user.AuthorityRegion.includes(item.CompanyId));
            //   return of(new featureActions.LoadAccounts({accounts: data}));
            // }
          } else {
            return of(new featureActions.GetAccountsFail());
          }
        })
      );
    })
  ));
  ReadAllAuthorityInfo$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.AuthorityActionTypes.GetAllAuthoritys),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.accountService.ReadAllAuthorityInfo(user.otp).pipe(
        map((res: any) => {
          return new featureActions.LoadAuthoritys({authoritys: res});
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetAuthoritysFail());
        })
      );
    })
  ));

  // @Effect()
  // ReadAccountList$: Observable<any> = this.actions$.pipe(
  //   ofType(featureActions.AccountActionTypes.GetAccountList),
  //   withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
  //   switchMap(([action, user]) => {
  //     const idList = action.payload;
  //     return this.accountService.ReadAccountInfo(user.otp).pipe(
  //       map((res: any) => {
  //         if (!(res.length > 0)) {
  //           return of(new featureActions.NoAccountsChanged());
  //         } else {
  //           const data = (idList && idList.length > 0) ? res.filter(item => idList.includes(item.Acode)) : res;
  //           return new featureActions.LoadAccounts({accounts: data});
  //         }
  //       }),
  //       // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
  //       catchError(error => {
  //         return of(new featureActions.GetAccountsFail());
  //       })
  //     );
  //   })
  // );
}
